import { render, staticRenderFns } from "./FilingView.vue?vue&type=template&id=5b20dbb0&scoped=true&"
import script from "./FilingView.vue?vue&type=script&lang=js&"
export * from "./FilingView.vue?vue&type=script&lang=js&"
import style0 from "./FilingView.vue?vue&type=style&index=0&id=5b20dbb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b20dbb0",
  null
  
)

export default component.exports